/**
 * EnrollmentService
 *
 * Regras de Negócio:
 * - Se ativo: Matrícula afeta todas as sessões da data em diante (type="regular").
 * - Se inativo/lead: Matrícula afeta apenas uma única sessão (type="trial").
 * - Desnormalização: Os dados do aluno são gravados no array `attendances` da sessão.
 * - Contadores separados: `enrolledCount` (regulares) e `experimentalCount` (experimentais) na sessão.
 * - Turma (class): `enrolledCount` é incrementado ao matricular aluno regular.
 *
 * Módulos internos:
 *   queries.js    — leituras (list, get)
 *   mutations.js  — escritas (enroll, cancel)
 *   helpers.js    — helpers internos (activities, waitlist)
 */
import { listMemberEnrollments, listAllMemberEnrollments, getEnrolledMembersByClass } from "./queries";
import { enrollMember, enrollClassPackage, scheduleTrialClass, cancelEnrollment } from "./mutations";
import { updateMemberActivities, notifyWaitlistOnVacancy } from "./helpers";

export const EnrollmentService = {
    _updateMemberActivities: updateMemberActivities,
    _notifyWaitlistOnVacancy: notifyWaitlistOnVacancy,
    listMemberEnrollments,
    listAllMemberEnrollments,
    enrollMember,
    enrollClassPackage,
    scheduleTrialClass,
    cancelEnrollment,
    getEnrolledMembersByClass,
};

export default EnrollmentService;
